<template>
  <v-app-bar
    class="header-desktop"
    hide-on-scroll
    elevate-on-scroll
    scroll-threshold="300"
    color="white"
    height="145px"
    app
  >
    <v-container class="py-0" style="height: 100%">
      <v-sheet
        width="100%"
        height="100%"
        color="transparent"
        class="d-flex justify-space-between align-center"
      >
        <router-link to="/">
          <img
            v-if="informations.img"
            :src="files + informations.img"
            :alt="informations.name"
            class="d-block"
            height="110px"
          />
        </router-link>

        <v-sheet
          class="d-flex flex-column justify-space-between align-end"
          width="calc(100% - 450px)"
          height="100%"
        >
          <div
            class="
              primary
              d-flex
              align-center
              py-4
              pl-5
              pr-0
              position-relative
              main-header-top
            "
          >
            <v-text-field
              v-model="search"
              class="rounded-pill"
              :class="{ 'mr-5': informations.tel || social.length }"
              append-icon="fas fa-search"
              label="Buscar"
              hide-details
              dense
              solo
              flat
            ></v-text-field>

            <template v-if="informations.tel">
              <v-btn
                class="text-body-1 text-md-subtitle-1 font-weight-regular px-2"
                :class="{ 'mr-5': social.length }"
                color="secondary"
                :href="getTelLinkFromPhone(informations.tel)"
                target="_blank"
                text
              >
                <v-icon class="mr-2" color="secondary" size="16">
                  fa-phone-alt
                </v-icon>

                {{ informations.tel }}
              </v-btn>
            </template>

            <v-sheet
              v-if="informations.tel && social.length"
              class="mr-5"
              color="secondary"
              height="30px"
              width="1px"
            ></v-sheet>

            <template v-if="social.length">
              <v-btn
                v-for="({ text, link, icon }, i) in social"
                :key="i"
                class="ml-2"
                :href="link"
                color="secondary"
                target="_blank"
                depressed
                :title="text"
                x-small
                fab
              >
                <v-icon color="primary">{{ icon }}</v-icon>
              </v-btn>
            </template>
          </div>

          <div class="d-flex align-center mb-4">
            <div>
              <div
                v-for="({ text, to, dropdown }, keyMenu) in menu"
                :key="keyMenu"
                class="d-inline-flex"
              >
                <v-btn
                  v-if="!dropdown"
                  class="
                    text-caption text-lg-body-1 text-none text-uppercase
                    font-weight-bold
                    px-2 px-lg-3
                    py-5
                    nav-link
                  "
                  color="secondary lighten-3"
                  :to="to"
                  active-class="nav-link-active"
                  tile
                  depressed
                  text
                >
                  {{ text }}
                </v-btn>

                <v-menu v-else offset-y tile>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      class="
                        text-caption text-lg-body-1 text-none text-uppercase
                        font-weight-bold
                        px-2 px-lg-3
                        py-5
                        nav-link
                      "
                      color="secondary lighten-3"
                      active-class="nav-link-active"
                      tile
                      depressed
                      text
                    >
                      {{ text }}
                      <v-icon class="ml-3" size="12"> fa-caret-down </v-icon>
                    </v-btn>
                  </template>
                  <v-list tile>
                    <v-list-item
                      v-for="(item, keyDropdown) in dropdown"
                      :key="keyDropdown"
                      :to="item.to"
                    >
                      <v-list-item-title class="grey--text text--darken-3">
                        {{ item.text }}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>

                <v-divider
                  class="my-2 mx-3 grey lighten-2"
                  v-if="keyMenu + 1 !== menu.length"
                  vertical
                />
              </div>
            </div>
          </div>
        </v-sheet>
      </v-sheet>
    </v-container>
  </v-app-bar>
</template>

<script>
import { getSocial } from "../../../utils/getSocial";
import { getTelLinkFromPhone } from "../../../utils/getTelLinkFromPhone";
import { productFilter } from "../../../utils/productFilter";
import { menu } from "../../../config";

export default {
  data: () => ({
    menu,
  }),
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    social() {
      return getSocial(this.informations);
    },
  },
  methods: {
    getTelLinkFromPhone,
  },
  mixins: [productFilter],
};
</script>

<style lang="scss" scoped>
.header-desktop::v-deep {
  overflow: hidden;

  .v-toolbar__content {
    padding: 0;
  }

  .main-header-top {
    border-bottom-left-radius: 12px;
    border-top-left-radius: 12px;
    width: 100%;

    &:before {
      background-color: var(--v-primary-base);
      content: "";
      height: 100%;
      left: 100%;
      margin-left: -2px;
      position: absolute;
      width: 2000%;
    }
  }
}

.nav-link {
  position: relative;

  &:after {
    content: "";
    background: var(--v-primary-base);
    bottom: -2px;
    display: block;
    height: 2px;
    left: 50%;
    margin-left: 0;
    position: absolute;
    transition: 0.5s;
    width: 0%;
  }

  &-active {
    &:before {
      background-color: transparent !important;
    }

    &:after {
      margin-left: -21px;
      width: 42px;
    }
  }
}
</style>
